module.exports = __webpack_public_path__ + "img/CM-MS-24-Mitsubishi-Lifestyle.846e6828.jpg";